/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : Jul 27, 2025
Folder          : src/components/button
File            : ButtonCompDark.tsx
Description     : 
    This reusable component is a dark button.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/


// Import React Systems
import { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

// Import Firebase
import { onAuthStateChanged } from 'firebase/auth'
import { auth, db } from "../../../../backend/firebaseConfig"
import {  doc,
          getDoc, } from "firebase/firestore";

// Import Customized Components
import SidebarButtons from "./SidebarButtons"

// Imports MUI Components
import {  Box,
          Stack,
          Avatar } from "@mui/material"

// Import Functions
import { fetchUserDetails } from "../../../functions/fetchUserDetails"

const SidebarButtonsComp = ({
  open
}) => {
  // State to hold user details
  const [userDetails, setUserDetails] = useState(null);

  // UseEffects
  useEffect(() => {
    const details = fetchUserDetails(setUserDetails);
    return () => {
      details && details();
    };
  }, []);

  const boxStyleContainer = {
    height: "30vh",
    backgroundColor: "mediumaquamarine",
    overflow: "auto"
  }

  return (
    <div>
      {/* Button */}
      {userDetails?.role === "DentistOwner" ? (

        // Dentist Owner Sidebar Buttons
        <>
          <Box
            // sx={boxStyleContainer}
          >
          {[
            { to: "/dashboard", text: "Dashboard", img: "dashboard" },
            { to: "/patient-record", text: "Patient Record", img: "history" },
            { to: "/inventory", text: "Inventory", img: "inventory" },
            { to: "/manage-services", text: "Services", img: "services" },
            { to: "/analytics", text: "Analytics", img: "analytics" },
            { to: "/manage-personnel", text: "Manage Personnel", img: "manage" },
            { to: "/settings", text: "Settings", img: "settings" },
          ].map((button, index) => (

            // Link
            <Link
              key={index}
              to={button.to}
              onClick={(e) => {
                if (
                  button.to === "/dashboard" &&
                  (window.location.pathname === "/manage-appointment" ||
                    window.location.pathname === "/patient-appointment-booking")
                ) {
                  e.preventDefault();
                  window.location.assign(`${window.location.origin}/dashboard`);
                }
              }}
            >

              {/* Customized Sidebar Button */}
              <SidebarButtons
                color={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "transparent"}
                open={open}
                text={button.text}
                img={button.img}
                hover={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "rgba(253, 249, 243, .1)"}/>

            </Link>

          ))}
          </Box>
        </>
      ) : userDetails?.role === "ClinicStaff" ? (

        // Clinic Staff Sidebar Buttons
        <>
        
          {[
            { to: "/dashboard", text: "Dashboard", img: "dashboard" },
            { to: "/patient-record", text: "Patient Record", img: "history" },
            { to: "/inventory", text: "Inventory", img: "inventory" },
            { to: "/settings", text: "Settings", img: "settings" },
          ].map((button, index) => (
            
            // Link
            <Link
              key={index}
              to={button.to}
              onClick={(e) => {
                if (
                  button.to === "/dashboard" &&
                  (window.location.pathname === "/manage-appointment" ||
                    window.location.pathname === "/patient-appointment-booking")
                ) {
                  e.preventDefault();
                  window.location.assign(`${window.location.origin}/dashboard`);
                }
              }}
            >

              {/* Customized Sidebar Button */}
              <SidebarButtons
                color={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "#2E2D2D"}
                open={open}
                text={button.text}
                img={button.img}
                hover={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "rgba(253, 249, 243, .1)"}/>

            </Link>

          ))}

        </>
      ) : userDetails?.role === "AssociateDentist" ? (

        // Associate Dentist Sidebar Buttons
        <>
        
          {[
            { to: "/dashboard", text: "Dashboard", img: "dashboard" },
            { to: "/patient-record", text: "Patient Record", img: "history" },
            { to: "/inventory", text: "Inventory", img: "inventory" },
            { to: "/manage-services", text: "Services", img: "services" },
            { to: "/settings", text: "Settings", img: "settings" },
          ].map((button, index) => (
            
            // Link
            <Link
              key={index}
              to={button.to}
              onClick={(e) => {
                if (
                  button.to === "/dashboard" &&
                  (window.location.pathname === "/manage-appointment" ||
                    window.location.pathname === "/patient-appointment-booking")
                ) {
                  e.preventDefault();
                  window.location.assign(`${window.location.origin}/dashboard`);
                }
              }}
            >

              {/* Customized Sidebar Button */}
              <SidebarButtons
                color={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "#2E2D2D"}
                open={open}
                text={button.text}
                img={button.img}
                hover={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "rgba(253, 249, 243, .1)"}/>

            </Link>

          ))}

        </>

      ) : userDetails?.role === "Patient" ? (

        // Patient Sidebar Buttons
        <>

          {[
            { to: "/dashboard", text: "Dashboard", img: "dashboard" },
            { to: "/treatment-history", text: "Treatment History", img: "history" },
            { to: "/settings", text: "Settings", img: "settings" },
          ].map((button, index) => (

            // Link
            <Link
              key={index}
              to={button.to}
              onClick={(e) => {
                if (
                  button.to === "/dashboard" &&
                  (window.location.pathname === "/manage-appointment" ||
                    window.location.pathname === "/patient-appointment-booking")
                ) {
                  e.preventDefault();
                  window.location.assign(`${window.location.origin}/dashboard`);
                }
              }}
            >

              {/* Customized Sidebar Button */}
              <SidebarButtons
                color={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "transparent"}
                open={open}
                text={button.text}
                img={button.img}
                hover={window.location.pathname === button.to ? "rgba(253, 249, 243, .2)" : "rgba(253, 249, 243, .1)"}/>

            </Link>

          ))}

        </>

      ) : (
        <></>
      )}
    </div>
  )
}

export default SidebarButtonsComp
